module.exports = __webpack_public_path__ + "media/images/footer/sfa-ac48de414e05f3c14f93ae977b24f4e1.png";